import { AlertIcon } from '@starrez/starryui';
import { color, Text, HStack } from '@starrez/starryui9';
import React from 'react';
import styled from 'styled-components';

interface IValidationErrorProps {
    children: React.ReactNode;
    showIcon?: boolean;
    id: string;
}

export const ValidationError = ({ showIcon = true, id, children }: IValidationErrorProps) => (
    <HStack gap="xxSmall" columns="max-content">
        {showIcon && (
            <IconContainer>
                <HStack>
                    <AlertIcon Width="18px" Height="18px" />
                </HStack>
            </IconContainer>
        )}
        <span aria-live="assertive" id={id} role="alert">
            <Text color={color.Red.R60}>{children}</Text>
        </span>
    </HStack>
);

const IconContainer = styled.div`
    color: ${color.Red.R60};
`;
